/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Accountingcategory_Debitor8Inputs */



/**

* @param {_Field__Enum_Accountingcategory_Debitor8Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_accountingcategory_debitor8 = /** @type {((inputs?: _Field__Enum_Accountingcategory_Debitor8Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Accountingcategory_Debitor8Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Debitor")
});
export { _field__enum_accountingcategory_debitor8 as "_field__enum_accountingCategory_DEBITOR" }